import React from 'react';

const ImageModalContext = React.createContext<{ openImageModal(imageSrc: string): void }>({
  openImageModal: (imageSrc: string) => undefined,
});

export default ImageModalContext;
